module.exports = __webpack_public_path__ + "assets/img/saules-elektrines-slaitinis-stogas.06cab636.jpg";